export default "#version 300 es\nprecision highp float;\n\nout float fragCoverage;\n\nvoid main() {\n\n    fragCoverage = 1.0;\n}\n"